const backdrop = {
  styleOverrides: {
    root: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
    }
  }
};

export default backdrop;
